import Error from 'entities/error'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { head } from 'lodash'
import 'styles/components/form-error-text.scss'

// FormErrorTextに合ったデータ配列を作ります
export const getErrorMessage = (errors = null, key) => {
  if (!errors && !errors[key]) {
    return null
  }
  const error = [[key, head(errors)]]
  return error
}

// eslint-disable-next-line react/prefer-stateless-function
export default class FormErrorText extends Component {
  render() {
    const { name, errors } = this.props
    if (!errors) {
      return null
    }

    const messages = errors
      .filter(e => name === null || e[0] === name)
      // eslint-disable-next-line react/no-array-index-key
      .map((e, i) => <span key={i}>{e[1]}</span>)

    if (messages.length === 0) {
      return null
    }

    return <div className="form-error-text">{messages}</div>
  }
}

FormErrorText.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  errors: PropTypes.array,
  name: PropTypes.string
}

FormErrorText.defaultProps = {
  errors: null,
  name: null
}

export const FormErrorTextV2 = ({ errors, name }) => {
  if (!errors) {
    return null
  }

  const messages = errors
    .filter(e => name === null || e.key === name)
    .map(e => <span key={e.message}>{e.message}</span>)

  if (messages.length === 0) {
    return null
  }

  return <div className="form-error-text">{messages}</div>
}

FormErrorTextV2.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.instanceOf(Error)),
  name: PropTypes.string
}

FormErrorTextV2.defaultProps = {
  errors: null,
  name: null
}
